import { Link } from "react-router-dom"
import DashboardSideBar from "../../components/dashboardSidebar"
import Footer from "../../components/footer"
import Header from "../../components/header"
import SideBar from "../../components/sidebar"
import services from "../../services"
import { useEffect, useState } from "react"
import moment from "moment"

import { isMobile } from 'react-device-detect';
import constant from "../../constant"
import { TripTypeBadge, KmBadge, CostHighlight } from "../../components/bookingMeta";
import useIsMobile from "../../hooks/useIsMobile";
import MobileFooter from "../../components/MobileFooter";
import MobileHeader from "../../components/MobileHeader";
const Dashboard = () =>{
    const isMobile = useIsMobile();
    const [bookingList, setBookingList] = useState([])
    const [pendingbooking, setpendingbooking] = useState(0)
    const [completedbooking, setcompletedbooking] = useState(0)
    const [upcomingbooking, setupcomingbooking] = useState(0)
    const [oneWayList, setOneWayList] = useState([])
    useEffect(()=>{
        getBookingsHandler();
        getOneWayBookingsHandler();
    },[])
    // Customer's confirmed one-way trips
    const getOneWayBookingsHandler = async () => {
        try {
            const response = await services.order.GET_MY_ONE_WAY_BOOKINGS();
            setOneWayList(Array.isArray(response?.data) ? response.data : [])
        } catch (error) {
            console.log(error)
        }
    }
    const tripDay = (item) => moment(item.vendorOneWayAvailability?.tripDate)
    const todayOneWay = oneWayList.filter((item) => tripDay(item).isSame(moment(), 'day'))
    const upcomingOneWay = oneWayList.filter((item) => !tripDay(item).isBefore(moment(), 'day')).length
    const getBookingsHandler = async() =>{
        try {
            const response = await services.order.GET_BOOKING();
            console.log(response)
            let data = response.data;
            if (data.length) {
                data.map((item) => {
                    item.BookingDetails.sort(function (a, b) {
                        return parseFloat(a.id) - parseFloat(b.id);
                    });
                })
                var newArray = data.filter(function (el) {
                    return el.BookingDetails[0].bookingStatus == 'confirmed' || el.BookingDetails[0].bookingStatus == 'accepted';
                  });
                var ended = data.filter(function (el) {
                    return el.BookingDetails[0].bookingStatus == 'ended';
                  });
                var pending = data.filter(function (el) {
                    return el.BookingDetails[0].bookingStatus == 'pending';
                  });
                  setupcomingbooking(newArray.length)
                  setcompletedbooking(ended.length)
                  setpendingbooking(pending.length)
                setBookingList(newArray)
            }
           
        } catch (error) {
            console.log(error)
        }
    }
    if (isMobile) {
        let user = {};
        try { user = JSON.parse(localStorage.getItem('userDetails')) || {}; } catch (e) { user = {}; }
        return (
            <>
                <SideBar />
                <main className="mlux">
                    <MobileHeader right={<Link to="/myprofile" className="mlux-avatar"><i className="far fa-user"></i></Link>} />
                    <div className="mlux-greet" style={{ margin: '8px 4px 2px' }} data-rise="1">
                        <div className="kick">Welcome back</div>
                        <div className="nm" style={{ fontSize: 24 }}>{user?.firstName ? `Hi, ${user.firstName} 👋` : 'Your dashboard'}</div>
                    </div>

                    <div className="mlux-stats" data-rise="2">
                        <div className="mlux-stat up"><div className="n">{upcomingbooking || 0}</div><div className="l">Upcoming</div></div>
                        <div className="mlux-stat"><div className="n">{completedbooking || 0}</div><div className="l">Completed</div></div>
                        <div className="mlux-stat"><div className="n">{pendingbooking || 0}</div><div className="l">Pending</div></div>
                    </div>

                    <Link to="/" className="mlux-btn" style={{ marginTop: 16, textDecoration: 'none' }} data-rise="2"><i className="fas fa-plus"></i> Book a new ride</Link>

                    <div className="mlux-sec-head"><h3>Upcoming trips</h3><Link to="/mybookings">See all</Link></div>

                    {bookingList && bookingList.length ? bookingList.map((item) => (
                        <Link to={`/booking/${item.id}`} className="mlux-card mlux-trip" key={item.id} data-rise="3" style={{ display: 'block', textDecoration: 'none', color: 'inherit' }}>
                            <div className="thead">
                                <div>
                                    <div className="car">{item.Car?.brand} {item.Car?.name}</div>
                                    <div className="bid">Booking #{item.id}</div>
                                </div>
                                <span className="status">{item.BookingDetails?.[0]?.bookingStatus}</span>
                            </div>
                            <div className="mlux-date"><i className="far fa-calendar"></i>{moment(item.tripStartDate).format('ddd, DD MMM')}</div>
                            <div className="mlux-route">
                                <div className="pt from"><small>From</small>{item?.BookingDetails?.[0]?.pickupLocation?.addressLine}</div>
                                <div className="pt to"><small>To</small>{item?.BookingDetails?.[0]?.dropLocation?.addressLine}</div>
                            </div>
                            <div className="tmeta">
                                <TripTypeBadge tripType={item.tripType} />
                                <KmBadge item={item} />
                                <span className="cost"><CostHighlight item={item} /></span>
                            </div>
                        </Link>
                    )) : (
                        <div className="mlux-card mlux-empty" data-rise="3">
                            <div className="ic"><i className="far fa-calendar"></i></div>
                            <h4>No upcoming trips</h4>
                            <p>Book your next ride and it'll show up here.</p>
                            <Link to="/" className="mlux-btn ghost" style={{ textDecoration: 'none' }}><i className="fas fa-magnifying-glass"></i> Find a cab</Link>
                        </div>
                    )}

                    <div className="mlux-sec-head"><h3>One-way trips</h3><Link to="/mybookings">See all</Link></div>
                    <div className="mlux-stats" data-rise="2">
                        <div className="mlux-stat up"><div className="n">{todayOneWay.length}</div><div className="l">Today</div></div>
                        <div className="mlux-stat"><div className="n">{upcomingOneWay}</div><div className="l">Upcoming</div></div>
                        <div className="mlux-stat"><div className="n">{oneWayList.length}</div><div className="l">Total confirmed</div></div>
                    </div>

                    <div className="mlux-sec-head"><h3>Today's one-way trips</h3></div>
                    {todayOneWay.length ? todayOneWay.map((item) => {
                        const av = item.vendorOneWayAvailability || {};
                        const vc = av.vendorCar || {};
                        const car = vc.Car || {};
                        const phone = av.contactNumber || vc.User?.phoneNumber || '';
                        return (
                            <div className="mlux-card mlux-trip" key={item.id} data-rise="3">
                                <div className="thead">
                                    <div>
                                        <div className="car">{car.brand || 'One-way'} {car.name || 'cab'}</div>
                                        <div className="bid">One-way · {item.passengerCount || 1} pax</div>
                                    </div>
                                    <span className="status" style={{ color: '#16a34a', background: 'rgba(22,163,74,0.12)' }}>Confirmed</span>
                                </div>
                                <div className="mlux-date"><i className="far fa-calendar"></i>{moment(av.tripDate).format('ddd, DD MMM')}</div>
                                <div className="mlux-route">
                                    <div className="pt from"><small>From</small>{av.from?.full_address || av.from?.addressLine || '—'}</div>
                                    <div className="pt to"><small>To</small>{av.to?.full_address || av.to?.addressLine || '—'}</div>
                                </div>
                                {phone && (
                                    <div style={{ marginTop: 12 }}>
                                        <a className="mlux-callbtn" href={`tel:${String(phone).replace(/[^\d+]/g, '')}`}><i className="fas fa-phone"></i> Call partner</a>
                                    </div>
                                )}
                            </div>
                        );
                    }) : (
                        <div className="mlux-card mlux-empty" data-rise="3">
                            <div className="ic"><i className="fas fa-route"></i></div>
                            <h4>No one-way trips today</h4>
                            <p>Empty-return cabs are cheaper — find one going your way.</p>
                            <Link to="/oneway" className="mlux-btn ghost" style={{ textDecoration: 'none' }}><i className="fas fa-magnifying-glass"></i> Find one-way cabs</Link>
                        </div>
                    )}
                </main>
                <MobileFooter />
            </>
        );
    }

    return (<>
    <Header/>
    <SideBar/>
        <main class="main">

       


        <div class="user-profile py-5">
            <div class="container">
                <div class="row">
                   <DashboardSideBar/>
                   <div class="col-lg-9">
                        <div class="user-profile-wrapper">
                            <div class="row">
                                <div class="col-md-6 col-lg-4">
                                    <div class="dashboard-widget dashboard-widget-color-1">
                                        <div class="dashboard-widget-info">
                                            <h1>{upcomingbooking}</h1>
                                            <span>Upcoming Booking</span>
                                        </div>
                                        <div class="dashboard-widget-icon">
                                            <i class="fal fa-list"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-4">
                                    <div class="dashboard-widget dashboard-widget-color-2">
                                        <div class="dashboard-widget-info">
                                            <h1>{completedbooking}</h1>
                                            <span>Completed Booking</span>
                                        </div>
                                        <div class="dashboard-widget-icon">
                                            <i class="fal fa-eye"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-4">
                                    <div class="dashboard-widget dashboard-widget-color-3">
                                        <div class="dashboard-widget-info">
                                            <h1>{pendingbooking}</h1>
                                            <span>Pending Booking</span>
                                        </div>
                                        <div class="dashboard-widget-icon">
                                            <i class="fal fa-xmark-circle"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-lg-4">
                                    <div class="dashboard-widget dashboard-widget-color-1">
                                        <div class="dashboard-widget-info">
                                            <h1>{todayOneWay.length}</h1>
                                            <span>Today's One-Way Trips</span>
                                        </div>
                                        <div class="dashboard-widget-icon">
                                            <i class="fal fa-route"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-4">
                                    <div class="dashboard-widget dashboard-widget-color-2">
                                        <div class="dashboard-widget-info">
                                            <h1>{upcomingOneWay}</h1>
                                            <span>Upcoming One-Way</span>
                                        </div>
                                        <div class="dashboard-widget-icon">
                                            <i class="fal fa-calendar"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-4">
                                    <div class="dashboard-widget dashboard-widget-color-3">
                                        <div class="dashboard-widget-info">
                                            <h1>{oneWayList.length}</h1>
                                            <span>Confirmed One-Way</span>
                                        </div>
                                        <div class="dashboard-widget-icon">
                                            <i class="fal fa-check-circle"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="user-profile-card">
                                        <h4 class="user-profile-card-title">Today's One-Way Trips</h4>
                                        {todayOneWay.length ? (
                                            <div class="table-responsive">
                                                <table class="table text-nowrap">
                                                    <thead>
                                                        <tr>
                                                            <th>Cab Info</th>
                                                            <th>Pickup and drop</th>
                                                            <th>Passengers</th>
                                                            <th>Partner Contact</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {todayOneWay.map((item) => {
                                                            const av = item.vendorOneWayAvailability || {};
                                                            const car = av.vendorCar?.Car || {};
                                                            const phone = av.contactNumber || av.vendorCar?.User?.phoneNumber || '';
                                                            return (
                                                                <tr key={item.id}>
                                                                    <td><h6 class="mb-0">{car.brand} {car.name}</h6></td>
                                                                    <td style={{ whiteSpace: 'normal', minWidth: 180 }}>
                                                                        <span>{av.from?.full_address || '—'}</span> <br />
                                                                        <span>{av.to?.full_address || '—'}</span>
                                                                    </td>
                                                                    <td>{item.passengerCount || 1}</td>
                                                                    <td>{phone ? <a href={`tel:${phone}`}>{phone}</a> : '—'}</td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        ) : (
                                            <div class="text-center py-4">
                                                <p class="mb-3">No one-way trips today</p>
                                                <Link to="/oneway" class="theme-btn"><i class="far fa-search"></i> Find one-way cabs</Link>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="user-profile-card">
                                        <h4 class="user-profile-card-title">Upcoming Booking</h4>
                                        {isMobile ? <div class="container my-3">

{bookingList?.map((item) => {
    return (<Link to={`/booking/${item.id}`} class="card booking-card">
        <div class="d-flex justify-content-between align-items-center">

            <div class="booking-info">
                <h6 className="mb-0">{item.Car.brand} {item.Car.name}</h6>
                <span>Booking ID: #{item.id}</span>
            </div>
            <img src={constant.IMAGE_URL + (item?.VendorCar?.photos?.[0] || item?.Car?.photos?.[0] || '')} crossorigin="anonymous" class="rounded-circle" alt="Driver image" />
        </div>
        <div className="d-flex justify-content-between">
            <div class="mt-1">
                <span><strong>From : </strong>{item?.BookingDetails[0].pickupLocation.addressLine}</span> <br />
                <span><strong>to : </strong>{item?.BookingDetails[0].dropLocation.addressLine}</span>
            </div>
            <div class="mt-1">
                <span>{moment(item.tripStartDate).format('DD/MM/YY')}</span>
                <p>{moment(item.tripEndDate).format('DD/MM/YY')}</p>
            </div>
        </div>

        <div class="d-flex justify-content-between mt-2">
            <span class={`badge badge-status badge-${(item.bookingStatus == 'failed' || item.bookingStatus == 'cancelled' || item.bookingStatus == 'rejected') ? 'danger' : 'primary'} text-capitalize`}>{(item.bookingStatus == 'failed' || item.bookingStatus == 'cancelled' || item.bookingStatus == 'rejected') ? item.bookingStatus : item.BookingDetails[0].bookingStatus}</span>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}><TripTypeBadge tripType={item.tripType} /><KmBadge item={item} /><CostHighlight item={item} /></span>
        </div>
    </Link>)
})}



</div>
:
<div class="table-responsive">
    <table class="table text-nowrap">
        <thead>
            <tr>
                <th className="">Cab Info</th>
                <th>Journey Date</th>
                <th>Pickup and drop</th>
                <th>Trip / KM</th>
                <th>Price</th>
                <th>Status</th>
                <th>Action</th>
            </tr>
        </thead>
        <tbody>
            {bookingList?.map((item) => {
                return (<tr key={item.id}>
                    <td>
                        <div class="table-list-info">
                            <a href="#">
                                {/* <img src="/assets/img/taxi/01.png" alt/> */}
                                <div class="table-list-content">
                                    <h6>{item.Car.brand} {item.Car.name}</h6>
                                    <span>Booking ID: #{item.id}</span>
                                </div>
                            </a>
                        </div>
                    </td>
                    <td>
                        <span>{moment(item.tripStartDate).format('DD/MM/YY')}</span>
                        <p>{moment(item.tripEndDate).format('DD/MM/YY')}</p>
                    </td>
                    <td>
                        <span>{item?.BookingDetails[0].pickupLocation.addressLine}</span> <br />
                        <span>{item?.BookingDetails[0].dropLocation.addressLine}</span>
                        {/* <p>03:15 PM</p> */}
                    </td>
                    <td><div className="d-flex flex-column align-items-start" style={{ gap: '4px' }}><TripTypeBadge tripType={item.tripType} /><KmBadge item={item} /></div></td>
                    <td><CostHighlight item={item} /></td>
                    <td><span class={`badge badge-${(item.bookingStatus == 'failed' || item.bookingStatus == 'cancelled' || item.bookingStatus == 'rejected') ? 'danger' : 'primary'} text-capitalize`}>{(item.bookingStatus == 'failed' || item.bookingStatus == 'cancelled' || item.bookingStatus == 'rejected') ? item.bookingStatus : item.BookingDetails[0].bookingStatus}</span></td>
                    <td>
                        <Link to={`/booking/${item.id}`}
                            class="btn btn-outline-secondary btn-sm rounded-2"
                            data-bs-toggle="tooltip" title="Details"><i
                                class="far fa-eye"></i></Link>
                    </td>
                </tr>)
            })}

        </tbody>
    </table>
</div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </main>
    {/* <Footer/> */}
    </>
    )
}
export default Dashboard